// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings_wrapper__8osLQ {
    display: flex;
    padding-top:10px;
    padding-bottom: 10px;
    align-items: center;
}

.settings_headSkin__FmKJ0 {
    color: whitesmoke;
    background-color: transparent;
    font-size: 20px;
    font-family: 'Poppins', sans-serif;
    letter-spacing: 0.5px;
}
.settings_BlcokInf__QdwOQ{
    display: flex;
    padding: 10px;
    background: rgb(28 39 54);
    cursor: pointer;
    font-size: 20px;
    font-family: monospace,sans-serif;
    color:white;
    border-radius: 10px;
    
}
.settings_passwordContainer__uog52{
    width: 100%;
    position: relative;
}



.settings_close__v27rq {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

@keyframes settings_fadeIn__CpVB0 {
    from {
        opacity: 0;
        transform: translateY(-200px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.settings_bg_LoginForm__5\\+XqN{
    min-height: 100svh;
    overflow: auto;

}

/* Design the webpage */
.settings_contentFormLogin__kWBcL{

}
.settings_icon_copy__3Ttln{
    font-size: 20px;
    color:green;
    cursor: pointer;
}
.settings_model_box__tfPG0{
    width: 100%;
    
}
/* Basic structure of login form */
.settings_model_box__tfPG0 form {


    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap:20px;
    align-items: center;

    padding:10px;
    background: linear-gradient(0deg, #000, #272727);
    

    box-sizing: border-box;

    border-radius: 10px;
}
.settings_wrapperButtons__J8AX7{
    display: flex;

}
.settings_buttonCancel__D8rGU{
    display: flex;
    justify-content: center;
    background-color: grey!important;
    margin:0 auto;
}
.settings_buttonAccept__edalB{

    display: flex;
    justify-content: center;
    margin:0 auto;
    background-color: #4251cb;
    width: 100%;
}
/*.reg{*/
/*  height:400px !important;*/
/*}*/
/*.model_box form:before, .model_box form:after{*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: -2px;*/
/*  top: -2px;*/
/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/
/*  #0000ff, #00ff00,#ffff00, #ff0000);*/
/*  border-radius: 10px;*/
/*  background-size: 400%;*/
/*  width: calc(100% + 4px);*/
/*  height: calc(100% + 4px);*/
/*  z-index: -1;*/
/*  animation: steam 20s linear infinite;*/
/*}*/


form *{
    font-family: 'Poppins',sans-serif;
    color: #ffffff;
    letter-spacing: 0.5px;
    outline: none;
    border: none;
}

.settings_bg_LoginForm__5\\+XqN{
    min-height: 100svh;
    overflow: auto;

}

/* Design the webpage */
.settings_contentFormLogin__kWBcL{
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* Basic structure of login form */
.settings_model_box__tfPG0 form {


    position: relative;
    display: flex;
    flex-direction: column;
    /*height: 520px;*/

    padding: 50px 35px;
    background: linear-gradient(rgb(47 42 3) 0%, rgb(218 192 87) 100%);
    box-sizing: border-box;

    border-radius: 10px;
}
/*.reg{*/
/*  height:400px !important;*/
/*}*/
/*.model_box form:before, .model_box form:after{*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: -2px;*/
/*  top: -2px;*/
/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/
/*  #0000ff, #00ff00,#ffff00, #ff0000);*/
/*  border-radius: 10px;*/
/*  background-size: 400%;*/
/*  width: calc(100% + 4px);*/
/*  height: calc(100% + 4px);*/
/*  z-index: -1;*/
/*  animation: steam 20s linear infinite;*/
/*}*/


form *{
    font-family: 'Poppins',sans-serif;
    color: #ffffff;
    letter-spacing: 0.5px;
    outline: none;
    border: none;
}

@keyframes settings_steam__0\\+-c1 {
    0% {
        background-position: 0 0;
    }
    50% {
        background-position: 400% 0;
    }
    100% {
        background-position: 0 0;
    }
}
.settings_model_box__tfPG0 h2 {
    font-size: 32px;
    font-weight: 500;
    line-height: 42px;
    text-align: center;

    color: #fff;
    text-align: center;
}



.settings_model_box__tfPG0 input,textarea {
    display: block;
    height: 50px;
    width: 350px;
    background-color: rgba(255,255,255,0.07);
    border-radius: 3px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 300;
    box-sizing: border-box; /* Добавляем box-sizing со значением border-box */

}
.settings_linksBlock__Clisc{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap:1rem;
    height: 50px;
    background-color: rgba(255,255,255,0.07);
    border-radius: 3px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 300;
    cursor: pointer;
    box-sizing: border-box; /* Добавляем box-sizing со значением border-box */

}
.settings_password__9oOJr{
    color:#fff;
    margin-bottom: 30px;
}





.settings_switchBlock__MMzQU {
    display: flex;
    justify-content: center;
}
.settings_linksBlock__Clisc {
    display: flex;
    align-items: center;
    height: 40px;
    border: none;
    padding:10px;
    background-color: rgb(32 38 250 / 57%);
    border-radius: 10px;
    padding: 0 10px;

    font-weight: 300;
    cursor: pointer;

}
.settings_blockRefUser__\\+I2fv{
    
    color:white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap:10px;
    align-items: center;
    background:linear-gradient(315deg, rgb(133, 122, 8) 0%, rgba(243, 218, 132, 0.66) 100%);
    border-radius: 10px;
    padding:10px;

    font-family: Poppins, sans-serif;
    font-size: 15px;
    width: 100%;
}
.settings_head__UUr1W {
    color: white;
    font-size: 25px;
    font-family: "Montserrat", sans-serif;
    padding: 10px;
    position: relative;
}

.settings_head__UUr1W:before {

    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: -10px;
    width: 100%;
    height: 2px;
    background: #8080801f;
    margin-bottom: 10px;


}
@media screen and (max-width: 1000px) {
    .settings_wrapper__8osLQ{
        flex-direction: column;
    }
    .settings_blockRefUser__\\+I2fv{
        font-size: 11px;
    }
    .settings_headSkin__FmKJ0{
        font-size: 13px;

    }
    .settings_linksBlock__Clisc{
        font-size: 11px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Settings/settings.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,kCAAkC;IAClC,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,WAAW;IACX,mBAAmB;;AAEvB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,6BAA6B;IACjC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,kBAAkB;IAClB,cAAc;;AAElB;;AAEA,uBAAuB;AACvB;;AAEA;AACA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;;AAEf;AACA,kCAAkC;AAClC;;;IAGI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;;IAEnB,YAAY;IACZ,gDAAgD;;;IAGhD,sBAAsB;;IAEtB,mBAAmB;AACvB;AACA;IACI,aAAa;;AAEjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,aAAa;AACjB;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;AACA,QAAQ;AACR,6BAA6B;AAC7B,IAAI;AACJ,iDAAiD;AACjD,iBAAiB;AACjB,wBAAwB;AACxB,gBAAgB;AAChB,eAAe;AACf,4FAA4F;AAC5F,wCAAwC;AACxC,yBAAyB;AACzB,2BAA2B;AAC3B,6BAA6B;AAC7B,8BAA8B;AAC9B,iBAAiB;AACjB,0CAA0C;AAC1C,IAAI;;;AAGJ;IACI,iCAAiC;IACjC,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;;AAElB;;AAEA,uBAAuB;AACvB;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,kCAAkC;AAClC;;;IAGI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;IAEjB,kBAAkB;IAClB,kEAAkE;IAClE,sBAAsB;;IAEtB,mBAAmB;AACvB;AACA,QAAQ;AACR,6BAA6B;AAC7B,IAAI;AACJ,iDAAiD;AACjD,iBAAiB;AACjB,wBAAwB;AACxB,gBAAgB;AAChB,eAAe;AACf,4FAA4F;AAC5F,wCAAwC;AACxC,yBAAyB;AACzB,2BAA2B;AAC3B,6BAA6B;AAC7B,8BAA8B;AAC9B,iBAAiB;AACjB,0CAA0C;AAC1C,IAAI;;;AAGJ;IACI,iCAAiC;IACjC,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,WAAW;IACX,kBAAkB;AACtB;;;;AAIA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB,EAAE,iDAAiD;;AAE7E;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB,EAAE,iDAAiD;;AAE7E;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;;;;;AAMA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;;IAEf,gBAAgB;IAChB,eAAe;;AAEnB;AACA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,uFAAuF;IACvF,mBAAmB;IACnB,YAAY;;IAEZ,gCAAgC;IAChC,eAAe;IACf,WAAW;AACf;AACA;IACI,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,mBAAmB;;;AAGvB;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;;IAEnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".wrapper {\n    display: flex;\n    padding-top:10px;\n    padding-bottom: 10px;\n    align-items: center;\n}\n\n.headSkin {\n    color: whitesmoke;\n    background-color: transparent;\n    font-size: 20px;\n    font-family: 'Poppins', sans-serif;\n    letter-spacing: 0.5px;\n}\n.BlcokInf{\n    display: flex;\n    padding: 10px;\n    background: rgb(28 39 54);\n    cursor: pointer;\n    font-size: 20px;\n    font-family: monospace,sans-serif;\n    color:white;\n    border-radius: 10px;\n    \n}\n.passwordContainer{\n    width: 100%;\n    position: relative;\n}\n\n\n\n.close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-200px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n.bg_LoginForm{\n    min-height: 100svh;\n    overflow: auto;\n\n}\n\n/* Design the webpage */\n.contentFormLogin{\n\n}\n.icon_copy{\n    font-size: 20px;\n    color:green;\n    cursor: pointer;\n}\n.model_box{\n    width: 100%;\n    \n}\n/* Basic structure of login form */\n.model_box form {\n\n\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap:20px;\n    align-items: center;\n\n    padding:10px;\n    background: linear-gradient(0deg, #000, #272727);\n    \n\n    box-sizing: border-box;\n\n    border-radius: 10px;\n}\n.wrapperButtons{\n    display: flex;\n\n}\n.buttonCancel{\n    display: flex;\n    justify-content: center;\n    background-color: grey!important;\n    margin:0 auto;\n}\n.buttonAccept{\n\n    display: flex;\n    justify-content: center;\n    margin:0 auto;\n    background-color: #4251cb;\n    width: 100%;\n}\n/*.reg{*/\n/*  height:400px !important;*/\n/*}*/\n/*.model_box form:before, .model_box form:after{*/\n/*  content: '';*/\n/*  position: absolute;*/\n/*  left: -2px;*/\n/*  top: -2px;*/\n/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/\n/*  #0000ff, #00ff00,#ffff00, #ff0000);*/\n/*  border-radius: 10px;*/\n/*  background-size: 400%;*/\n/*  width: calc(100% + 4px);*/\n/*  height: calc(100% + 4px);*/\n/*  z-index: -1;*/\n/*  animation: steam 20s linear infinite;*/\n/*}*/\n\n\nform *{\n    font-family: 'Poppins',sans-serif;\n    color: #ffffff;\n    letter-spacing: 0.5px;\n    outline: none;\n    border: none;\n}\n\n.bg_LoginForm{\n    min-height: 100svh;\n    overflow: auto;\n\n}\n\n/* Design the webpage */\n.contentFormLogin{\n    font-family: sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n/* Basic structure of login form */\n.model_box form {\n\n\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    /*height: 520px;*/\n\n    padding: 50px 35px;\n    background: linear-gradient(rgb(47 42 3) 0%, rgb(218 192 87) 100%);\n    box-sizing: border-box;\n\n    border-radius: 10px;\n}\n/*.reg{*/\n/*  height:400px !important;*/\n/*}*/\n/*.model_box form:before, .model_box form:after{*/\n/*  content: '';*/\n/*  position: absolute;*/\n/*  left: -2px;*/\n/*  top: -2px;*/\n/*  background: linear-gradient(45deg, #fb0094, #0000ff, #00ff00,#ffff00, #ff0000, #fb0094,*/\n/*  #0000ff, #00ff00,#ffff00, #ff0000);*/\n/*  border-radius: 10px;*/\n/*  background-size: 400%;*/\n/*  width: calc(100% + 4px);*/\n/*  height: calc(100% + 4px);*/\n/*  z-index: -1;*/\n/*  animation: steam 20s linear infinite;*/\n/*}*/\n\n\nform *{\n    font-family: 'Poppins',sans-serif;\n    color: #ffffff;\n    letter-spacing: 0.5px;\n    outline: none;\n    border: none;\n}\n\n@keyframes steam {\n    0% {\n        background-position: 0 0;\n    }\n    50% {\n        background-position: 400% 0;\n    }\n    100% {\n        background-position: 0 0;\n    }\n}\n.model_box h2 {\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 42px;\n    text-align: center;\n\n    color: #fff;\n    text-align: center;\n}\n\n\n\n.model_box input,textarea {\n    display: block;\n    height: 50px;\n    width: 350px;\n    background-color: rgba(255,255,255,0.07);\n    border-radius: 3px;\n    padding: 0 10px;\n    font-size: 14px;\n    font-weight: 300;\n    box-sizing: border-box; /* Добавляем box-sizing со значением border-box */\n\n}\n.linksBlock{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap:1rem;\n    height: 50px;\n    background-color: rgba(255,255,255,0.07);\n    border-radius: 3px;\n    padding: 0 10px;\n    font-size: 14px;\n    font-weight: 300;\n    cursor: pointer;\n    box-sizing: border-box; /* Добавляем box-sizing со значением border-box */\n\n}\n.password{\n    color:#fff;\n    margin-bottom: 30px;\n}\n\n\n\n\n\n.switchBlock {\n    display: flex;\n    justify-content: center;\n}\n.linksBlock {\n    display: flex;\n    align-items: center;\n    height: 40px;\n    border: none;\n    padding:10px;\n    background-color: rgb(32 38 250 / 57%);\n    border-radius: 10px;\n    padding: 0 10px;\n\n    font-weight: 300;\n    cursor: pointer;\n\n}\n.blockRefUser{\n    \n    color:white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap:10px;\n    align-items: center;\n    background:linear-gradient(315deg, rgb(133, 122, 8) 0%, rgba(243, 218, 132, 0.66) 100%);\n    border-radius: 10px;\n    padding:10px;\n\n    font-family: Poppins, sans-serif;\n    font-size: 15px;\n    width: 100%;\n}\n.head {\n    color: white;\n    font-size: 25px;\n    font-family: \"Montserrat\", sans-serif;\n    padding: 10px;\n    position: relative;\n}\n\n.head:before {\n\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 0;\n    bottom: -10px;\n    width: 100%;\n    height: 2px;\n    background: #8080801f;\n    margin-bottom: 10px;\n\n\n}\n@media screen and (max-width: 1000px) {\n    .wrapper{\n        flex-direction: column;\n    }\n    .blockRefUser{\n        font-size: 11px;\n    }\n    .headSkin{\n        font-size: 13px;\n\n    }\n    .linksBlock{\n        font-size: 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `settings_wrapper__8osLQ`,
	"headSkin": `settings_headSkin__FmKJ0`,
	"BlcokInf": `settings_BlcokInf__QdwOQ`,
	"passwordContainer": `settings_passwordContainer__uog52`,
	"close": `settings_close__v27rq`,
	"bg_LoginForm": `settings_bg_LoginForm__5+XqN`,
	"contentFormLogin": `settings_contentFormLogin__kWBcL`,
	"icon_copy": `settings_icon_copy__3Ttln`,
	"model_box": `settings_model_box__tfPG0`,
	"wrapperButtons": `settings_wrapperButtons__J8AX7`,
	"buttonCancel": `settings_buttonCancel__D8rGU`,
	"buttonAccept": `settings_buttonAccept__edalB`,
	"linksBlock": `settings_linksBlock__Clisc`,
	"password": `settings_password__9oOJr`,
	"switchBlock": `settings_switchBlock__MMzQU`,
	"blockRefUser": `settings_blockRefUser__+I2fv`,
	"head": `settings_head__UUr1W`,
	"fadeIn": `settings_fadeIn__CpVB0`,
	"steam": `settings_steam__0+-c1`
};
export default ___CSS_LOADER_EXPORT___;
